import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1ce8522c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-container" }

import { ref, computed } from "vue";
import { useRoute } from "vue-router";

import BreadCrumbs from "@/shared/menu/BreadCrumbs.vue";
import Button from "primevue/button";
import TopPanel from "@/widgets/sidebars/TopPanel.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopTraficPlanPanel',
  props: {
    isLoading: { type: Boolean },
    isButtonDisabled: { type: Boolean }
  },
  emits: ["createTraficPlan"],
  setup(__props: any, { emit: __emit }) {



const route = useRoute();

const emit = __emit;

const nameEdit = computed(() => {
  return route.params.id ? "Редактирование" : "Создание";
});

const items = ref([
  { label: "Кастомизация" },
  { label: "План трафика", route: "traficPlanList" },
  { label: `${nameEdit.value} плана трафика` },
]);

const createTraficPlan = () => {
  emit("createTraficPlan");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TopPanel, null, {
    default: _withCtx(() => [
      _createVNode(BreadCrumbs, {
        items: items.value,
        class: "s-bread"
      }, null, 8, ["items"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Button), {
          label: "Сохранить план трафика",
          class: "save-button m-l-16 m-r-16",
          onClick: createTraficPlan,
          disabled: _ctx.isButtonDisabled,
          loading: _ctx.isLoading
        }, null, 8, ["disabled", "loading"])
      ])
    ]),
    _: 1
  }))
}
}

})